import React from 'react';
import { InputGroup } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { SearchWrapper } from 'components/styled-components';
import debounce from 'lodash/debounce';
import constants from 'utils/constants';

const keywords = ['Pre-Screen Questions', 'Questionnaire Questions', 'Mapping'];

export const QuestionnaireControls = ({
  value,
  active,
  handleSearch,
  children,
}) => {
  const throttledSearch = debounce(
    handleSearch,
    constants.SEARCH_TYPING_DELAY_MILLISECONDS
  );

  const handleQueryChange = e => throttledSearch(e.target.value);

  return (
    <React.Fragment>
      <SearchWrapper justify="flex-start">
        <InputGroup
          title="SearchBar"
          leftIcon={IconNames.SEARCH}
          placeholder={`Search ${keywords[active]}`}
          onChange={handleQueryChange}
          className="medium-text-group light-blue"
        />
        {children}
      </SearchWrapper>
    </React.Fragment>
  );
};
